<script setup>
  import { computed } from "vue";
  import { useRoute, useRouter } from "vue-router";

  import { allNavList } from "@/config/navList";

  const emits = defineEmits(["navigate"]);
  const route = useRoute();
  const router = useRouter();

  const isNavActive = (nav) => route.path.startsWith(nav.path);

  const getNavPath = (nav) => nav?.children?.[0]?.path ?? nav.path;

  const handleClick = (nav) => {
    router.push(getNavPath(nav));
    emits("navigate");
  };

  // 헤더 GNB 2행은 검사 3종만 노출 (리뉴얼 시안 문구)
  const gnbTitleMap = {
    "/exam/s-plan": "문해력·수리력 진단검사(S-PLAN)",
    "/exam/ai-literacy": "AI·디지털 리터러시 진단검사",
    "/exam/essay": "AI·서논술형 평가(채움AI)",
  };

  const filteredNavList = computed(() => {
    return allNavList
      .filter((nav) => gnbTitleMap[nav.path])
      .map((nav) => ({ ...nav, title: gnbTitleMap[nav.path] }));
  });
</script>

<template>
  <nav class="nh-2" aria-label="검사 메뉴">
    <a
      v-for="nav in filteredNavList"
      :key="nav.path"
      href="#none"
      :class="{ 'is-active': isNavActive(nav) }"
      :aria-current="isNavActive(nav) ? 'page' : undefined"
      @click.prevent="handleClick(nav)"
    >
      {{ nav.title }}
    </a>
  </nav>
</template>

<style lang="scss" scoped>
  .nh-2 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    a {
      display: inline-flex;
      align-items: center;
      height: 42px;
      padding: 0 24px;
      border-radius: 60px;
      font-size: 16px;
      font-weight: 600;
      color: #464c53;
      white-space: nowrap;
      transition: background 0.15s, color 0.15s;

      &:hover {
        background: #f5f7fa;
        color: #1e2124;
      }

      &.is-active {
        background: #0a7cff;
        color: #fff;
        font-weight: 700;
        box-shadow: 0 4px 10px rgba(10, 124, 255, 0.28);
      }
    }
  }
</style>
